export const selectUser = (state) => state.user.user;

